import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { MailCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { http, formatApiError } from "@/lib/api";

export default function ForgotPasswordPage() {
    const [email, setEmail] = useState("");
    const [busy, setBusy] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await http.post("/auth/forgot-password", { email });
            setSent(true);
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="forgot-password-page">
            <div className="w-full max-w-md">
                <div className="text-sm tracking-[0.25em] uppercase text-primary mb-4 font-medium">Mot de passe oublié</div>
                <h1 className="font-serif text-4xl sm:text-5xl mb-6">Retrouver l'accès</h1>
                {sent ? (
                    <div className="rounded-3xl border border-primary/30 bg-primary/5 p-6 flex gap-3" data-testid="forgot-password-sent">
                        <MailCheck className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                        <p className="text-sm text-foreground/80">
                            Si un compte existe pour <strong>{email}</strong>, un e-mail vient de partir avec un lien pour choisir un nouveau mot de passe (valable 1 heure). Pensez à regarder dans vos courriers indésirables.
                        </p>
                    </div>
                ) : (
                    <form onSubmit={submit} className="space-y-6">
                        <p className="text-foreground/70">Indiquez l'e-mail de votre compte : nous vous enverrons un lien pour choisir un nouveau mot de passe.</p>
                        <div>
                            <Label htmlFor="email" className="mb-2 block">Email</Label>
                            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-full" data-testid="forgot-password-email" />
                        </div>
                        <Button type="submit" disabled={busy} className="w-full h-12 rounded-full" data-testid="forgot-password-submit">
                            {busy ? "Envoi…" : "Recevoir le lien"}
                        </Button>
                    </form>
                )}
                <p className="mt-8 text-sm text-muted-foreground text-center">
                    <Link to="/connexion" className="text-primary underline underline-offset-4" data-testid="forgot-back-login">Retour à la connexion</Link>
                </p>
            </div>
        </div>
    );
}
